var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.jobs.length > 0)?_c('WorkCardRepair',{attrs:{"data":_vm.jobs}}):_c('h4',{staticClass:"mensaje"},[_vm._v("No tienes trabajos asignados por ahora.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }